import React from "react";
import {
  Form,
  Input,
  Button,
  InputNumber,
  Select,
  Space,
  Typography,
  Divider,
} from "antd";
import { DollarOutlined } from "@ant-design/icons";

const { Text } = Typography;
const { Option } = Select;

const PaymentForm = ({ echeance, onFinish, onCancel, loading = false }) => {
  const [form] = Form.useForm();

  // Set initial values
  React.useEffect(() => {
    form.setFieldsValue({
      amount: parseFloat(echeance.amount),
      payment_method: "cash",
      reference_number: "",
    });
  }, [form, echeance]);

  // Format date for display
  const formatDate = (dateString) => {
    if (!dateString) return "";

    const date = new Date(dateString);
    return date.toLocaleDateString("fr-FR", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });
  };

  // Format currency for display
  const formatCurrency = (amount) => {
    if (amount === null || amount === undefined) return "";

    return new Intl.NumberFormat("fr-MA", {
      style: "currency",
      currency: "MAD",
      minimumFractionDigits: 2,
    }).format(amount);
  };

  // Watch for payment method changes to show/hide reference field
  const paymentMethod = Form.useWatch("payment_method", form);

  return (
    <Form
      form={form}
      layout="vertical"
      onFinish={onFinish}
      initialValues={{
        amount: parseFloat(echeance.amount),
        payment_method: "cash",
      }}
    >
      <div className="mb-4">
        <Text strong>Période:</Text> {formatDate(echeance.start_date)} -{" "}
        {formatDate(echeance.end_date)}
      </div>

      <div className="mb-4">
        <Text strong>Montant total:</Text> {formatCurrency(echeance.amount)}
      </div>

      <Divider />

      <Form.Item
        name="amount"
        label="Montant du paiement"
        rules={[
          { required: true, message: "Veuillez entrer le montant" },
          {
            type: "number",
            min: parseFloat(echeance.amount),
            message:
              "Le montant doit être supérieur ou égal à la somme restante",
          },
        ]}
      >
        <InputNumber
          prefix={<DollarOutlined />}
          className="w-full"
          min={echeance.amount - 0.01}
          step={0.01}
        />
      </Form.Item>
      {console.log(
        form.getFieldValue("amount"),
        typeof form.getFieldValue("amount"),
        echeance.amount,
        typeof parseFloat(echeance.amount)
      )}
      <Form.Item
        name="payment_method"
        label="Méthode de paiement"
        rules={[
          {
            required: true,
            message: "Veuillez sélectionner une méthode de paiement",
          },
        ]}
      >
        <Select>
          <Option value="cash">Espèces</Option>
          <Option value="card">Carte bancaire</Option>
          <Option value="bank_transfer">Virement bancaire</Option>
          <Option value="cheque">Chèque</Option>
        </Select>
      </Form.Item>

      {paymentMethod && paymentMethod !== "cash" && (
        <Form.Item
          name="reference_number"
          label="Numéro de référence"
          rules={[
            {
              required: true,
              message: "Veuillez entrer le numéro de référence",
            },
          ]}
        >
          <Input placeholder="Ex: TR-123456" />
        </Form.Item>
      )}

      <Form.Item className="mb-0">
        <Space className="w-full flex justify-end">
          <Button onClick={onCancel} disabled={loading}>Annuler</Button>
          <Button type="primary" htmlType="submit" loading={loading} disabled={loading}>
            Traiter le paiement
          </Button>
        </Space>
      </Form.Item>
    </Form>
  );
};

export default PaymentForm;
